import React, { useState } from "react";
import useDocumentList from "../../hooks/useDocumentList";
import InvoiceDataGrid from "../invoiceList/InvoiceDataGrid";
import InvoiceActivityLogs from "../invoiceList/InvoiceActivityLogs";
import DocumentHeader from "../invoiceList/DocumentHeader";

const GitList = () => {
  const [p1Value, setP1Value] = useState("ALL");
  const [modalType, setModalType] = useState(null);

  const {
    config,
    searchTerm,
    setSearchTerm,
    searchType,
    setSearchType,
    showSidebar,
    setShowSidebar,
    columnVisibilityModel,
    setColumnVisibilityModel,
    documentData,
    columns,
    rows,
    selectionModel,
    setSelectionModel,
    selectedRowData,
    setSelectedRowData,
    loading,
    handleEdit,
    exportDocumentList,
    handleView,
    pageNumber,
    setPageNumber,
    currentEnd,
    currentStart,
    totalCount,
    refreshDocumentList,
  } = useDocumentList({
    docType: "GIT",
    p1Value,
    p2Value: "-",
    docNoField: "GIT NO",
    editRoute: "/goods_in_transit",
    screenCode: "GITCOUNT",
    initialSearchType: "-",
  });
  const handleExport = () => {
    exportDocumentList();
  };
  return (
    <div className=" bg-gray-50">
      <DocumentHeader
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
        BASE_URL={config.BASE_URL}
        COMPANY_CODE={config.COMPANY_CODE}
        DEPARTMENT={config.DEPARTMENT_NO}
        title="Goods In Transit List"
        searchTerm={searchTerm}
        searchType={searchType}
        setSearchTerm={setSearchTerm}
        setSearchType={setSearchType}
        filteredDocs={documentData}
        showType={p1Value}
        setShowType={setP1Value}
        total={totalCount}
        onExport={handleExport} 
        documentType={"GOODSINTRANSIT"}
        config={config}
        selectedRowData={selectedRowData}
        doctype="GIT NO"
        showFilter={false}
      />
      <div className="max-w-full mx-auto py-0 space-y-1">
        <div className="grid grid-cols-12 gap-4">
          {showSidebar && (
            <InvoiceActivityLogs
              invoiceId={selectedRowData["GIT NO"]}
              COMPANY_CODE={config.COMPANY_CODE}
              BASE_URL={config.BASE_URL}
              modificationType={"GITTIMELINE"}
              printType={"GITPRINTIMELINE"}
              DEPARTMENT={config.DEPARTMENT_NO}
            />
          )}
          <div
            className={`col-span-12 ${
              showSidebar ? "lg:col-span-9" : "lg:col-span-12"
            } transition-all duration-300`}
          >
            <InvoiceDataGrid
              rows={rows}
              columns={columns}
              loading={loading}
              selectionModel={selectionModel}
              setSelectionModel={setSelectionModel}
              setSelectedRowData={setSelectedRowData}
              selectedRowData={selectedRowData}
              onEdit={handleEdit}
              onView={handleView}
              columnVisibilityModel={columnVisibilityModel}
              setColumnVisibilityModel={setColumnVisibilityModel}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              currentStart={currentStart}
              currentEnd={currentEnd}
              totalCount={totalCount}
              showSidebar={showSidebar}
              docLabel={"GIT NO"}
              enableF5Action={false}
              config={config}
              refreshDocumentList={refreshDocumentList}
              modalType={"close"}
              setModalType={setModalType}
              f5Mode={""}
              showApproveReject={false}
              reviewMode=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GitList;
